import { useEffect, useState } from "react";

export const useScrollbarWidth = ({ trigger }: { trigger: any }): number => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const calcWidth = () => {
      const scrollDiv = document.createElement("div");
      scrollDiv.style.width = "100px";
      scrollDiv.style.height = "100px";
      scrollDiv.style.overflow = "scroll";
      scrollDiv.style.position = "absolute";
      scrollDiv.style.top = "-9999px";
      document.body.appendChild(scrollDiv);

      const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      setWidth(scrollbarWidth);
    };

    calcWidth();
  }, [trigger]);

  return width;
};
